import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import DebouncedSearchField from 'components/DebouncedSearchField';
import SearchInput from 'components/SearchInput';

class KeywordFilter extends Component {
    constructor(props) {
        super(props);

        this.handleClear = this.handleClear.bind(this);
    }

    handleClear() {
        this.props.onChange(this.props.filter.name, '');
    }

    render() {
        return (
            <DebouncedSearchField
                value={this.props.filter.value}
                name={this.props.filter.name}
                onChange={this.props.onChange}
                render={({ value, onChange }) => (
                    <SearchInput
                        name={this.props.filter.name}
                        id={`${this.props.filter.name}-keyword-filter`}
                        value={value}
                        onChange={onChange}
                        onClear={this.handleClear}
                        placeholder={this.props.filter.title}
                        subtitle={this.props.filter.subtitle}
                    />
                )}
            />
        );
    }
}

KeywordFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    filter: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

export default observer(KeywordFilter);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/KeywordFilter.jsx